import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../../_mApp/auth';
import Svg from '../../../../app/components/atoms/Svg';
import { toAbsoluteUrl } from '../../../helpers';
import { useLayout } from '../../core';
import { Header } from './Header';
import { DefaultTitle } from './page-title/DefaultTitle';
import { Topbar } from './Topbar';
import { searchArray } from '../../../../app/helpers/arr';

export function HeaderWrapper() {
    const { config, classes, attributes } = useLayout();
    const { header, aside } = config;
    const { currentUser } = useAuth();

    const logo = searchArray(currentUser?.company?.config?.logos, 'name', 'logo');

    return (
        <div
            id='kt_header'
            className={clsx('header', classes.header.join(' '), 'align-items-stretch')}
            style={{ backgroundColor: currentUser?.company?.brand?.header_bg_color || '#011627' }}
            data-kt-sticky='true'
            data-kt-sticky-name='header'
            data-kt-sticky-offset="{default: '200px', lg: '300px'}"
            {...attributes.headerMenu}>
            <div className={clsx(classes.headerContainer.join(' '), 'd-flex align-items-center')}>
                {/* begin::Aside mobile toggle */}
                {aside.display && (
                    <div
                        className='d-flex align-items-center d-lg-none ms-n3 me-1'
                        title='Show aside menu'>
                        <div
                            className='btn btn-icon btn-active-light-primary btn-custom w-30px h-30px w-md-40px h-md-40px'
                            id='kt_aside_mobile_toggle'>
                            <Svg
                                icon='hamburger'
                                className='svg-icon svg-icon-2x'
                            />
                        </div>
                    </div>
                )}
                {/* end::Aside mobile toggle */}

                <div
                    className='d-flex topbar align-items-center d-lg-none ms-n2 me-3'
                    title='Show aside menu'>
                    <div
                        className='btn btn-icon btn-active-light-primary btn-custom w-30px h-30px w-md-40px h-md-40px'
                        id='kt_header_menu_mobile_toggle'>
                        <Svg
                            icon='hamburger'
                            className='svg-icon svg-icon-2x'
                        />
                    </div>
                </div>

                <div className='header-logo me-2 flex-grow-1 flex-lg-grow-0'>
                    <Link to='/'>
                        <img
                            alt='Logo'
                            src={logo?.file_url || toAbsoluteUrl('/media/logos/default-dark.svg')}
                            className='logo-default h-30px'
                        />
                        <img
                            alt='Logo'
                            src={logo?.file_url || toAbsoluteUrl('/media/logos/default-dark.svg')}
                            className='logo-sticky h-25px'
                        />
                    </Link>
                </div>

                {/* begin::Wrapper */}
                <div className='d-flex align-items-stretch justify-content-between flex-lg-grow-1'>
                    {/* begin::Navbar */}
                    {header.left === 'menu' && (
                        <div
                            className='d-flex align-items-stretch'
                            id='kt_header_nav'>
                            <Header />
                        </div>
                    )}

                    {header.left === 'page-title' && (
                        <div
                            className='d-flex align-items-center'
                            id='kt_header_nav'>
                            <DefaultTitle />
                        </div>
                    )}

                    <div className='d-flex align-items-stretch flex-shrink-0'>
                        <Topbar />
                    </div>
                </div>
                {/* end::Wrapper */}
            </div>
        </div>
    );
}
